import { InfoCircleOutlined } from '@ant-design/icons';
import useTranslation from 'next-translate/useTranslation';

import EmptyCard from './empty-card';
import React from 'react';

export interface EditInformationCardProps {
  title: string;
  hasAccess?: boolean;
  content: React.ReactNode;
  extraAction?: React.ReactNode;
}

const EditInformationCard = ({
  title,
  content,
  extraAction,
}: EditInformationCardProps) => {
  const { t } = useTranslation('common');
  const dataTest = title.toLowerCase().replace(' ', '-');
  return (
    <div className="flex justify-between">
      <div className="flex-1 grid">
        <div className="flex gap-2 justify-between">
          <span className="text-primary-600 text-sm font-semibold mb-2">
            {title.toUpperCase()}
          </span>
          <div>{extraAction}</div>
        </div>
        <div data-test={dataTest + '-content'} className="overflow-auto">
          {content || (
            <EmptyCard
              title={t('no_information')}
              icon={<InfoCircleOutlined />}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default EditInformationCard;
